import React from "react";

const ClockIcon = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00002 3.16675C5.33064 3.16675 3.16669 5.33071 3.16669 8.00008C3.16669 10.6695 5.33064 12.8334 8.00002 12.8334C10.6694 12.8334 12.8334 10.6695 12.8334 8.00008C12.8334 5.33071 10.6694 3.16675 8.00002 3.16675ZM2.16669 8.00008C2.16669 4.77842 4.77836 2.16675 8.00002 2.16675C11.2217 2.16675 13.8334 4.77842 13.8334 8.00008C13.8334 11.2217 11.2217 13.8334 8.00002 13.8334C4.77836 13.8334 2.16669 11.2217 2.16669 8.00008ZM8.50002 7.50008V5.83341C8.50002 5.55727 8.27616 5.33341 8.00002 5.33341C7.72388 5.33341 7.50002 5.55727 7.50002 5.83341V8.00008C7.50002 8.27622 7.72388 8.50008 8.00002 8.50008H10.5C10.7762 8.50008 11 8.27622 11 8.00008C11 7.72394 10.7762 7.50008 10.5 7.50008H8.50002Z"
      fill="currentColor"
    />
  </svg>
);

export default ClockIcon;
